var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocalePtBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H3.75C2.09315 3 0.75 4.34315 0.75 6V18C0.75 19.6569 2.09315 21 3.75 21H20.25C21.9069 21 23.25 19.6569 23.25 18V6C23.25 4.34315 21.9069 3 20.25 3Z",
    fill: "#459A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.604 12L12 18L21.396 12L12 6L2.604 12Z",
    fill: "#FEDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
    fill: "#0A2172"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.875C9.75225 10.875 9.0315 10.9868 8.34525 11.1818C8.28675 11.4443 8.25075 11.7143 8.25 11.994C8.958 11.7578 9.71325 11.6243 10.4992 11.6243C12.3922 11.6243 14.1112 12.3713 15.3885 13.5803C15.5025 13.3358 15.5955 13.0808 15.6555 12.8108C14.2725 11.6078 12.4717 10.8735 10.4992 10.8735L10.5 10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocalePtBr);
export default __webpack_public_path__ + "static/media/icon-locale-pt-BR.dcfc7a42095c9c5232f52b010ba31072.svg";
export { ForwardRef as ReactComponent };